import {svg_include} from "base/functions";
import moment from "moment";

export function buildSearchResult(document) {
    let formatted_cin = getFormattedCin(document);

    return (
        eotwJSXFactory('a', {className: "result-link js-result", target: "_blank", 'data-title': document.activeRevision.values.cin + ': ' + document.activeRevision.values.title, href: "/pdfs/" + document.id + ".pdf"}, [
            eotwJSXFactory('article', {className: "result flex flex--row"}, [
                eotwJSXFactory('aside', {className: "result__index"}, [
                    eotwJSXFactory('div', {className: "result__small-text"}, ["Index #"]),
                    eotwJSXFactory('div', {className: "result__index-text"}, [formatted_cin])
                ]),
                eotwJSXFactory('div', {className: "result__content flex flex--row"}, [
                    eotwJSXFactory('div', {className: "result__text"}, [
                        eotwJSXFactory('h1', {unsafeHtml: document.activeRevision.values.title}),
                        eotwJSXFactory('div', {className: "result-meta flex flex--row flex--wrap"}, [

                                ('undefined' !== typeof document.activeRevision.values['date-of-address']) ? (
                                    eotwJSXFactory('div', {className: "result-meta__item"}, [
                                        eotwJSXFactory('span', {className: "result-meta__item-icon"}).html(svg_include('meta-date')),
                                        eotwJSXFactory('span', {className: "result-meta__item-text"}, [moment.unix(document.activeRevision.values['date-of-address'].timestamp).format("Do MMMM YYYY")])
                                    ])
                                ) : undefined,


                                ('undefined' !== typeof document.activeRevision.values['location-of-address'] && document.activeRevision.values['location-of-address'].trim().length > 0) ? (
                                    eotwJSXFactory('div', {className: "result-meta__item"}, [
                                        eotwJSXFactory('span', {className: "result-meta__item-icon"}).html(svg_include('meta-location')),
                                        eotwJSXFactory('span', {className: "result-meta__item-text"}, [document.activeRevision.values['location-of-address'].trim()])
                                    ])
                                ) : undefined,


                                ('undefined' !== typeof document.activeRevision.values['occasion'] && document.activeRevision.values['occasion'].trim().length > 0) ? (
                                    eotwJSXFactory('div', {className: "result-meta__item"}, [
                                        eotwJSXFactory('span', {className: "result-meta__item-icon"}).html(svg_include('meta-occasion')),
                                        eotwJSXFactory('span', {className: "result-meta__item-text"}, [document.activeRevision.values['occasion'].trim()])
                                    ])
                                ) : undefined,


                                (window.CATEGORIES_ACTIVE && 'undefined' !== typeof document.activeRevision.values.category && document.activeRevision.values.category.length > 0) ? (
                                    eotwJSXFactory('div', {className: "result-meta__item"}, [
                                        eotwJSXFactory('span', {className: "result-meta__item-icon"}).html(svg_include('meta-category')),
                                        eotwJSXFactory('span', {className: "result-meta__item-text"}, [document.activeRevision.values.category[0].name])
                                    ])
                                ) : undefined

                        ])
                    ]),
                    eotwJSXFactory('div', {className: "result__button-section"}, [
                        eotwJSXFactory('button', {className: "btn btn--download", type: "button"}, [
                            eotwJSXFactory('span', {className: "btn__icon btn__icon--download"}).html(svg_include('document-icon')),
                            eotwJSXFactory('span', {className: "btn__text btn__text--download"}, ["View Document"])
                        ])
                    ])
                ])
            ])
        ])
    );
}

export function getFormattedCin(document) {
    if (document.activeRevision.values.category[0].id === '92c2652afdcbf5f5' /* ADDRESS */) {
        return 'A' + ("000" + document.activeRevision.values.cin).substr(-3, 3);
    }
    if (document.activeRevision.values.category[0].id === '1d1bf5d6621bc998' /* TALK */) {
        return 'K' + ("000" + document.activeRevision.values.cin).substr(-3, 3);
    }

    return 'T' + ("000" + document.activeRevision.values.cin).substr(-3, 3);
}
